var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"error"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-inner"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"message"},[_vm._t("default")],2),_c('div',{staticClass:"btn-block"},[_vm._t("button")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }